<template lang="pug">
  ul.nav.navbar-nav.navbar-right
    //- li.clickable
    //-   a
    //-     .relative.inline
    //-       i.fa.fa-commenting
    //-       .badge.success 5
    li.dropdown.user.user-menu(v-if="isConnected")
      a.dropdown-toggle.clickable(data-toggle='dropdown')
        vue-object-img(:object='user')
      ul.dropdown-menu.nopadding
        // The user image in the menu
        li.user-header
          vue-object-img(:object='user', @click="$router.push('/profile/avatar')", role="button")
          p(v-if="user", @click="$router.push('/profile/info')", role="button")
            | {{user.name}}
            small {{$t('headerUserDropdown.memberSince')}} {{user.creationTime | unixtimeTo('L')}}
        // Menu Body
        li.user-body(@click='showContacts', role='button')
          a
            i.fa.fa-users
            |  {{$t('sidemenu.contacts')}}
        li.user-body(@click='showHelp', role='button')
          a.clickable
            i.fa.fa-question
            |  {{$t('sidemenu.help')}}
        li.user-body(@click='showKeyshortcuts', role='button')
          a.clickable
            i.fa.fa-keyboard-o
            |  {{$t('headerUserDropdown.keyShortcuts')}}
        router-link.user-body(tag='li', to="/profile", role='button')
          a.clickable
            i.fa.fa-cog
            |  {{$t('headerUserDropdown.profile')}}
        li.user-body(@click='logout', role='button')
          a.clickable
            i.fa.fa-power-off
            |  {{$t('headerUserDropdown.deconnect')}}
    li.dropdown.user.user-menu(v-else)
      a(@click="connect", role="button")
        span.hidden-xs {{$t('headerUserDropdown.connect')}} &nbsp;
        .profileImage.user
          i.fa.fa-user

</template>
<script>
import modalsBus from '@/components/shared/ModalsBus'
import eventsBus from '@/components/shared/EventsBus'
import {mapGetters} from 'vuex'
// import moment from 'moment'

import VueObjectImg from '@/components/shared/VueObjectImg'
import {unixtimeTo} from '@/components/shared/vue.globals'

export default {
  components: {
    VueObjectImg
  },
  computed: {
    ...mapGetters('user', [
      'isConnected',
      'user'
    ])
  },
  methods: {
    logout () {
      if (this.isConnected) {
        this.$store.dispatch('user/logout').then(() => {
          if (this.$route.meta && !this.$route.meta.needConnected) {
            return
          }
          this.$router.push({name: 'Welcome'})
        })
      }
    },
    showContacts () {
      this.$store.dispatch('groops/selectAllGroops')
      this.$router.push({name: 'Members'})
    },
    showHelp () {
      this.$store.dispatch('groops/selectAllGroops')
      setTimeout(() => {
        this.$router.push('support')
      }, 20)
    },
    showKeyshortcuts () {
      eventsBus.$emit(eventsBus.SHOW_KEYSHORTCUTS)
    },
    connect () {
      modalsBus.open(modalsBus.modals.CONNECTION)
    }
  },
  filters: {
    unixtimeTo
  }
}
</script>



// WEBPACK FOOTER //
// HeaderUserDropdown.vue?26d055ea